import { provider } from "@/provider.js"

export const extractCaseIdFromChannelURL = (url) => {
  const m = url.match(/\/case_blocks\/account\/\d+\/case\/([a-z0-9]*)\//)
  return m ? m[1] : undefined
}

export const subscribeToCaseChannel = async ({ commit }, data) => {
  if (data.currentUser) {
    await provider.subscribeToCasePresence(data.caseId)
    // await provider.enterCase(data.caseId)
    if (window.faye) {
      const url = `/case_blocks/account/${data.currentUser.account.id}/case/${data.caseId}/currently_viewing`
      const faye = window.faye
      await faye.subscribe(url, (result) => {
        if (result && result.type && result.type === "current_case_presence") {
          const currentViewers = result.viewers.map((u) => u.user_display_name)
          commit("caseViewersUpdate", { currentViewers, channel: result.channel })
        }
      })

      const payload = {
        user_id: data.currentUser.id,
        action: "enter",
        user_display_name: data.currentUser.displayName,
        status: "OK",
      }
      await faye.publish(url, payload)
    } else {
      console.error("No realtime channel found. Is Faye enabled?")
    }
  } else {
    console.error("No currentUser set, cannot subscribe to channel.")
  }
}

export const unsubscribeToCaseChannel = async (_, data) => {
  // const url = `/case_blocks/account/${data.currentUser.account.id}/case/${data.caseId}/currently_viewing`;
  // const payload = {
  //   user_id: data.currentUser.id,
  //   action: "exit",
  //   user_display_name: data.currentUser.displayName,
  //   status: "OK"
  // };
  // const faye = window.faye;
  // await faye.publish(url, payload);
  // commit("caseViewersUpdate", {currentViewers: [], channel: url})
  // faye.removeAllListeners()
}

export const subscribeToCaseChannelV2 = async ({ commit }, data) => {
  if (data.currentUser) {
    const caseViewerObserver = await provider.subscribeToCasePresence(data.caseId)
    commit("setCaseViewerObserver", caseViewerObserver)
    // await provider.enterCase(data.caseId)
  } else {
    console.error("No currentUser set, cannot subscribe to channel.")
  }
}

export const unsubscribeToCaseChannelV2 = async ({ rootState, commit }, data) => {
  await provider.exitCase(data.caseId)

  await provider.unsubscribeFromCasePresence(rootState.ui.caseViewerObserver)
  commit("unsetCaseViewerObserver")
}
